<!-- 성분 분석 뷰 컴포넌트 -->
<template>
    <div class="stack-chart-view" style="height: 50rem">
        <div v-if="!isEmpty(sumNodeTrend)" class="col-12" style="height: 45%; margin-bottom: 1.5rem">
            <SumNodeMainTrendPanel
                v-if="!isEmpty(sumNodeTrend.results) && isSumNodeTrend"
                :baseData="sumNodeTrend"
                :dispBaseIdx="currentNode.sysNodeIdx"
                :compData="rltdTrendData"
                :dispCompIdx="selectedRltdPtIdx"
                :queryType="queryType"
                :predictData="predictData"
                :predictTitle="'예측값'"
                :unit="currentNode.sumUnit"
            />
            <div
                v-else
                class="empty-state"
                style="
                    height: 100%;
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                "
            >
                <span class="detail-notification-icon">
                    <i class="fas fa-exclamation-circle"></i>
                </span>
                <span class="detail-notification-text">표시할 데이터가 없습니다.</span>
            </div>
        </div>
        <div
            v-if="!isEmpty(baseChartData)"
            class="col-12"
            style="height: 50%; padding-top: 1.5rem; border-top: 1px solid #ececec"
        >
            <StackAreaChartPanel :baseChartData="baseChartData" />
        </div>
        <div
            v-else
            class="empty-state"
            style="
                height: 100%;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
            "
        >
            <span class="detail-notification-icon">
                <i class="fas fa-exclamation-circle"></i>
            </span>
            <span class="detail-notification-text">표시할 데이터가 없습니다.</span>
        </div>
    </div>
</template>

<script>
import SumNodeMainTrendPanel from "../../panel/SumNodeMainTrendPanel.vue";
import StackAreaChartPanel from "../../panel/StackAreaChartPanel.vue";

export default {
    name: "StackChartView",
    components: {
        SumNodeMainTrendPanel,
        StackAreaChartPanel,
    },
    props: {
        sumNodeTrend: {
            type: Object,
            default: null,
        },
        isSumNodeTrend: {
            type: Boolean,
            default: false,
        },
        currentNode: {
            type: Object,
            required: true,
        },
        rltdTrendData: {
            type: Object,
            default: null,
        },
        selectedRltdPtIdx: {
            type: [Number, String],
            default: null,
        },
        queryType: {
            type: String,
            default: "NOW",
        },
        predictData: {
            type: Array,
            default: () => [],
        },
        baseChartData: {
            type: [Object, Array],
            default: null,
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../styles/common/_detail-common.scss";

.stack-chart-view {
    /* 스타일은 필요시 추가 */
}
</style>
